"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url-search-params.js");

require("core-js/modules/es.function.name.js");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _settings = require("@/model/settings");

var _vuex = require("vuex");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getStaticCoinList as getCoinList } from "@/model/assets/index";
var _default = {
  mixins: [_commonMixin.default],
  data: function data() {
    return {
      marketing: 0,
      imageUrl: "",
      programForm: {
        name: "",
        email: "",
        contact: "",
        uid: "",
        tid: "",
        marketing: "",
        area: ""
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    systemCurrency: "user/currency",
    language: "user/language"
  })),
  watch: {},
  created: function created() {
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isType = file.type === "image/jpg" || file.type === "image/png";
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isType) {
        this.$message.error(this.translateTitle("上传头像图片只能是 JPG ｜ PNG 格式!"));
      }

      if (!isLt2M) {
        this.$message.error(this.translateTitle("上传头像图片大小不能超过 2MB!"));
      }

      return isType && isLt2M;
    },
    routeSplicing: _routeSplicing.default,
    goLogin: function goLogin() {
      if (!this.userInfo) {
        this.$message({
          message: this.translateTitle("请先登录"),
          type: "warning",
          customClass: "zZindex"
        });
        this.$router.push({
          path: this.routeSplicing(this.language, "login")
        });
      }
    },
    chooseMarketing: function chooseMarketing(index) {
      this.marketing = index;
    },
    goToRegister: function goToRegister() {
      this.$router.push(this.routeSplicing(this.language, "register"));
    },
    submit: function submit() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var req, _yield$apiBrokersProg, data, status;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = {
                  name: _this.programForm.name,
                  email: _this.programForm.email,
                  mobile: _this.programForm.area + "" + _this.programForm.contact,
                  telegram: _this.programForm.tid,
                  is_exceeded_1_million: _this.marketing,
                  pre_exchange_platform: _this.programForm.marketing,
                  screenshot: _this.imageUrl
                };
                _this.btnLoading = true;
                _context2.next = 4;
                return apiBrokersProgram(req);

              case 4:
                _yield$apiBrokersProg = _context2.sent;
                data = _yield$apiBrokersProg.data;
                status = _yield$apiBrokersProg.status;

                if (status == 200) {
                  _this.$message(_this.translateTitle("添加成功"), "success");
                }

                _this.btnLoading = false;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};
exports.default = _default;